import { connect } from 'react-redux';
import View from '../../components/ErrorHandler/errorHandlerView';
import { deleteNotification } from '../../actions/errorHandlerActions';
import {
  getLocalNotificationsReducer,
  getDurationReducer,
  getTotalNotificationsReducer
} from '../../selectors/errorHandlerSelector';

const mapStateToProps = state => ({
  duration: getDurationReducer(state),
  localNotificationsState: getLocalNotificationsReducer(state),
  totalNotifications: getTotalNotificationsReducer(state)
});

const mapDispatchToProps = dispatch => {
  return {
    deleteNotification: () => dispatch(deleteNotification())
  };
};

const Container = connect(mapStateToProps, mapDispatchToProps)(View);

export default Container;
